import { authorizedRequest } from 'api'
import { NetsuiteStudentProps } from 'types'
import { ErrorProp } from './'

export type ResponseProps = {
  total?: number
  results?: Partial<NetsuiteStudentProps>[]
  error?: ErrorProp | string | undefined
}

export type JsonResponse = {
  total?: ResponseProps['total']
  results?: ResponseProps['results']
  error?: ResponseProps['error']
}

export type SearchProps = {
  query?: string
}

export async function searchNetsuite({
  query = '',
}: SearchProps): Promise<ResponseProps> {
  const endpoint = 'search-netsuite'

  const search = {} as { [key: string]: string }
  if (query.includes('@')) {
    search.email = query.trim().toLowerCase()
  } else {
    search.forename = query.trim().split(' ')[0]
    search.surname = query.trim().split(' ').slice(1).join(' ')
  }

  const response = await authorizedRequest({
    endpoint,
    method: 'GET',
    params: search,
  })

  const json = await response.json()
  const { total, results, error }: JsonResponse = json

  if (response.ok) {
    return { results, total }
  } else {
    return Promise.reject(error ?? json.message)
  }
}
